import { observer } from 'mobx-react-lite'
import { SupportSection } from '@/features/jobs/details/components/SupportSection/index'
import { useFeatures } from '@/contexts/root-store-context'

/**
 * Support Section Container
 */
export const SupportSectionContainer = observer(
  function SupportSectionContainer() {
    const { openSupportChat, isSupportEnabled } = useFeatures(
      ({ support }) => ({
        openSupportChat: support.openSupportChat,
        isSupportEnabled: support.isSupportEnabled,
      }),
    )

    return (
      <SupportSection
        onContactSupportPress={isSupportEnabled() ? openSupportChat : undefined}
      />
    )
  },
)
